import React from 'react'

class UDStruct extends React.Component {
    constructor(props) {
        super(props);
    }

    render(){
        return(
            <div style={{marginLeft:6 + '%', width:120 + 'px',display:'inline-block'}}>
                <img src={this.props.image} style={{marginLeft:(120 - this.props.width) / 2 + 'px',display:'block',width:this.props.width,height:this.props.height}}/>
                <div style={{paddingLeft:10 + 'px',fontSize:12 + 'px',width:120 + 'px',textAlign:'center',marginTop:10 + 'px'}}>{this.props.content}</div>
            </div>
        );
    }
}

export default UDStruct